import types from "@/data/types"

/**
 * CSV export column order per request type.
 * Return null to keep default order (object key insertion order from frontend).
 * Return array of key names to enforce column order in the downloaded spreadsheet.
 */
const csvColumnOrder = (type) => {
    switch (type) {
        case types.TM_AM_SCRAPE:
            return [
                "team",
                "account",
                "event_id",
                "event",
                "alternative",
                "year",
                "date",
                "time",
                "venue",
                "section",
                "row",
                "seat",
                "qr",
                "additional"
            ]
        default:
            return null
    }
}

export default csvColumnOrder
